import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import CenIsGuestIsItemOverweightState from "@tCentro/Store/Reducer/CenIsGuestIsItemOverweightState";
import { Draft } from "immer";

const initialState: CenIsGuestIsItemOverweightState = {
    isGuestandIsOverweight: false,
};

const reducer = {
    "Pages/isGuestandIsOverweight": (
        draft: Draft<CenIsGuestIsItemOverweightState>,
        action: {
            isGuestandIsOverweight: boolean;
        },
    ) => {
        draft.isGuestandIsOverweight = action.isGuestandIsOverweight;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
